import React, { useEffect, useRef } from 'react';
import SliderItem from './SliderItem';
import Loading from '../common/Loading';

export default function Slider (props) {
  const typeClassName = props.type === 'event' ? 'thumb' : props.type; // poster, thumb, schedule

  let viewCount = 0;// 이벤트 페이지에서 빠져야하는 갯수 체크
  props.data.map((item, index) => {
    if (item.pc_view_yn === 'N') { // ---- 메인페이지 하단 이벤트 노출 부분에서  강제로 비활성화 기능있어서 추가
      viewCount = viewCount + 1;
    }
  });

  if (props.data) {
    let relateId;
    let relateTitle;
    let relateTitleViewYn;
    let relateType;
    let mediaId;

    if (props.relate_id != null) {
      relateId = props.relate_id;
      relateTitle = props.relate_title;
      relateTitleViewYn = props.relate_title_view_yn;
      relateType = props.relate_type;
    }
    return (
      <>
        {props.data.length > 0 && (<div role='region' className={`module_${typeClassName}_list_w`}>
          <div className={`module_${typeClassName}_list_swipe`} style={{ overflowY: 'scroll' }}>
            <ul className={`module_${typeClassName}_list_inner`}>
              {props.data.map((item, index) => {
                if (item.pc_view_yn !== 'N') { // ---- 메인페이지 하단 이벤트 노출 부분에서  강제로 비활성화 기능있어서 추가
                  return (
                    <SliderItem
                      key={index}
                      data={item || []}
                      type={props.type}
                      imageQuality={props.imageQuality}
                      relateId={relateId}
                      relateTitle={relateTitle}
                      relateTitleViewYn={relateTitleViewYn}
                      relateType={relateType}
                      mainContentsType={props.mainContentsType}
                      bottom_type={props.bottom_type}
                      clickParams={props.clickParams}
                    />
                  );
                }
              })}
            </ul>
          </div>
        </div>)}
      </>
    );
  } else {
    return (
      <div>
        <Loading />
        <p style={{ textAlign: 'center' }}>데이터를 찾을 수 없습니다...</p>
      </div>
    );
  }
}
